import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  InputAdornment,
  Button,
  FormHelperText,
  Snackbar,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import {
  validateEmailOTPAPICall,
  reSendEmailOTPAPICall,
} from "../shared/APICalls";
import { IEmailOTPValidation, IReSendEmailOTP } from "../shared/dtos";
import routesData from "../shared/routes.json";
import ConfitmEmailOtpStyles from "../pages/Styles/ConfirmEmailOtp.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import Slide, { SlideProps } from "@mui/material/Slide";
import LeftComp from "../Components/LeftComp/LeftComp";
import { MuiOtpInput } from "mui-one-time-password-input";
import GooglePlayStore from "../Components/assets/Images/GooglePlayStore.svg";
import AppStore from "../Components/assets/Images/AppStore.svg";
import MicroSoft from "../Components/assets/Images/MicrosoftStore.svg";
import fstlogo from "../Components/assets/Images/firstockLogoBadge.svg";
import leftcompimage from "../Components/assets/Images/SignupIllustration.svg";
import LeftCompNew from "../Components/LeftCompNew/LeftCompNew";

type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}
const dots = ["1", "2", "3", "4", "5", "6"];
export default function ConfirmEmailOtpPage() {
  const navigate = useNavigate();

  const clientEmail: any = sessionStorage.getItem("client-email");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState<any>(30);
  const [timerId, setTimerId] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const navigationData = routesData;
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsButtonDisabled(true);
    setCountdown(30);

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }, []);

  function emailOTPValidation(emailOTP: any) {
    // console.log("emailOTP", emailOTP);
    let obj: IEmailOTPValidation = {
      email: clientEmail,
      email_otp: emailOTP,
    };
    validateEmailOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setloading(false);

        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
        //navigate("/panverification");
      })
      .catch((error: any) => {
        setloading(false);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  function reSendemailOTP() {
    let obj: IReSendEmailOTP = {
      validation_id: "",
      email: clientEmail,
    };
    reSendEmailOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data.data;
        setloading(false);
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
        }, 3000);
        setIsButtonDisabled(true);
        setCountdown(30);
      })
      .catch((error: any) => {
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }

  const handleBackClick = () => {
    navigate("/email");
  };

  const handleResendOTP = () => {
    setloading(true);
    reSendemailOTP();
  };

  function validateEmailOTP(value: any) {
    let error: any;
    if (!value) {
      error = "Email OTP Required";
    } else if (!/^[0-9]{6}$/.test(value)) {
      error = "Must be a valid 6 digit OTP";
    }
    return error;
  }

  const handleChangeField = (
    name: any,
    value: any,
    setFieldValue: any,
    values: any,
  ) => {
    setFieldValue(name, value);
    //console.log( value);
    if (value.length === 6) {
      emailOTPValidation(value);
    }
  };

  const handleKeyPress = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValidKey = /^\d+$/.test(keyValue);

    if (!isValidKey) {
      event.preventDefault();
    }
  };

  return (
    <>
      <SnackBar message={message} />
      <div className={ConfitmEmailOtpStyles.layout}>
        <div className={ConfitmEmailOtpStyles.sidebar}>
          <LeftCompNew />
        </div>
        <div className={ConfitmEmailOtpStyles.pageContent}>
          <div className={ConfitmEmailOtpStyles.wrapper}>
            <div className={ConfitmEmailOtpStyles.RightContainer}>
              <div className={ConfitmEmailOtpStyles.contentSection}>
                <div className={ConfitmEmailOtpStyles.headerSection}>
                  <img
                    src={fstlogo}
                    alt=""
                    className={ConfitmEmailOtpStyles.fstlogo}
                    // style={{
                    //   filter:
                    //     mode === "dark"
                    //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                    //       : "",
                    // }}
                  />
                  <p className={ConfitmEmailOtpStyles.signup}>Enter the code</p>
                  <p className={ConfitmEmailOtpStyles.subText}>
                    We sent a 6-digit code to your <span>{clientEmail}</span>
                    <a
                      onClick={handleBackClick}
                      className={ConfitmEmailOtpStyles.change}
                    >
                      Change
                    </a>
                  </p>
                </div>

                <div className={ConfitmEmailOtpStyles.imageContainer}>
                  <LeftCompNew />
                </div>
                <Formik
                  initialValues={{
                    emailotp: "",
                  }}
                  onSubmit={(values) => {
                    //   console.log(values);
                    setloading(true);
                    emailOTPValidation(values.emailotp);
                  }}
                >
                  {({
                    errors,
                    touched,
                    handleChange,
                    values,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <Form
                      onKeyDown={(event) => {
                        event.code.includes("Enter") && handleSubmit();
                      }}
                      style={{ width: "100%" }}
                    >
                      <div className={ConfitmEmailOtpStyles.muiotp}>
                        <MuiOtpInput
                          length={6}
                          value={values.emailotp}
                          autoFocus
                          onChange={(event: any) => {
                            const updatedValue = event;

                            handleChangeField(
                              "emailotp",
                              updatedValue,
                              setFieldValue,
                              values,
                            );
                          }}
                          inputMode="numeric"
                          onKeyPress={handleKeyPress}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 0,
                              borderBottom: "1.5px solid #EDEDED !important",

                              "& fieldset": {
                                border: "none",
                              },

                              "&:hover fieldset": {
                                border: "none",
                              },

                              "&.Mui-focused fieldset": {
                                border: "none",
                              },
                            },
                            "& .MuiOutlinedInput-root.Mui-focused": {
                              borderBottom: "1.5px solid #535862 !important", // 🔵 focus color
                            },

                            "& .MuiOutlinedInput-input": {
                              borderRadius: 0,
                              padding: "0px !important",
                              height: "60px",
                              background: "transparent",
                            },
                          }}
                        />
                        {/* <Field
                          sx={{
                            fieldset: {
                              borderColor: "#E5E7EB",
                              borderRadius: "100px",
                              height: "60px",
                            },
                          }}
                          name="emailotp"
                          validate={validateEmailOTP}
                          render={({ field }) => (
                            <TextField
                              autoComplete="off"
                              autoFocus
                              {...field}
                              label=""
                              InputLabelProps={{ shrink: false }}
                              placeholder=""
                              // placeholder="••••••"
                              className={ConfitmEmailOtpStyles.textfield}
                              variant="outlined"
                              value={values.emailotp}
                              type="numeric"
                              onChange={(event) => {
                                const updatedValue = event.target.value;
                                handleChangeField(
                                  "emailotp",
                                  updatedValue,
                                  setFieldValue,
                                  values,
                                );
                              }}
                              inputProps={{
                                sx: {
                                  "&::placeholder": {
                                    paddingLeft: "-20px",

                                    fill: "var(--Black-Black-500, #6B7280)",
                                    fontWeight: 600,
                                    fontSize: "2.19rem",
                                    background: "transparent",
                                    height: "29px",
                                    letterSpacing: { xs: "23px", sm: "19px" },
                                  },
                                  // borderLeft: "1px solid #E5E7EB",
                                  // height: "30px",
                                  paddingLeft: "-20px",

                                  fontWeight: 500,
                                  letterSpacing: { xs: "29.5px", sm: "24.5px" },
                                  background: "transparent",
                                },
                                maxLength: 6,
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    style={{
                                      // borderRight: "1px solid #E5E7EB",
                                      // height: "22px",
                                      paddingRight: "10px",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    <img src={otpIcon} />
                                  </InputAdornment>
                                ),
                              }}
                              onKeyPress={(event) => {
                                const keyCode = event.keyCode || event.which;
                                const keyValue = String.fromCharCode(keyCode);
                                const isValidKey = /^\d+$/.test(keyValue);

                                if (!isValidKey) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          )}
                        /> */}
                        <FormHelperText
                          style={{
                            color: "#d32f2f",
                            // height: "10px",
                            marginTop: "3px",
                            // textAlign: "center",
                          }}
                        >
                          {touched.emailotp && errors.emailotp?.toString()}
                        </FormHelperText>

                        {isButtonDisabled ? (
                          <div className={ConfitmEmailOtpStyles.resendSection}>
                            <p className={ConfitmEmailOtpStyles.clickhere}>
                              Resend OTP in{" "}
                              <span style={{ color: "var(--ds-blue)" }}>
                                {countdown}
                              </span>{" "}
                              Seconds
                            </p>
                          </div>
                        ) : (
                          <div className={ConfitmEmailOtpStyles.resendSection}>
                            <LoadingButton
                              onClick={handleResendOTP}
                              disableFocusRipple
                              disableTouchRipple
                              disableElevation
                              focusRipple={false}
                              // loading={loading}
                              variant="text"
                              size="small"
                              id="confirmEmailOtpResendOTPButton"
                              sx={{
                                marginTop: "16px",
                                color: "var(--ds-blue)",
                                height: "25px !important",
                                padding: "0px 10px",
                                fontSize: "12px",
                              }}
                            >
                              Resend OTP
                            </LoadingButton>
                          </div>
                        )}

                        <div className={ConfitmEmailOtpStyles.buttonSection}>
                          {values.emailotp.length === 6 ? (
                            <LoadingButton
                              variant="contained"
                              type="submit"
                              loading={loading}
                              id="confirmEmailOtpContinueButton"
                              className={ConfitmEmailOtpStyles.button}
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              Continue
                            </LoadingButton>
                          ) : (
                            <Button
                              variant="contained"
                              disabled
                              id="confirmEmailOtpContinueDisabledButton"
                              className={ConfitmEmailOtpStyles.button}
                            >
                              Continue
                            </Button>
                          )}
                        </div>
                        <Snackbar
                          open={open}
                          autoHideDuration={3000}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          TransitionComponent={transition}
                          sx={{ marginTop: "50px" }}
                        >
                          <div
                            style={{
                              background: "#54BF00",
                              borderRadius: "10px ",
                            }}
                          >
                            <div style={{ marginLeft: "30px" }}>
                              <Alert
                                icon={false}
                                severity="success"
                                sx={{
                                  width: "max-content",
                                  height: "50px",
                                  fontSize: "16px",
                                  borderRadius: "0",
                                }}
                              >
                                Successfully sent the OTP to your Email.
                              </Alert>
                            </div>
                          </div>
                        </Snackbar>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className={ConfitmEmailOtpStyles.cardFooter}>
              <div className={ConfitmEmailOtpStyles.footerLinks}>
                <a
                  className={ConfitmEmailOtpStyles.footerItem}
                  href="https://firstock.in/faq/"
                  target="_blank"
                  rel="noreferrer"
                >
                  FAQ
                </a>
                <span
                  className={ConfitmEmailOtpStyles.footerSep}
                  aria-hidden="true"
                >
                  ·
                </span>
                <a
                  className={ConfitmEmailOtpStyles.footerItem}
                  href="https://firstock.in/support/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Support
                </a>
              </div>

              <p className={ConfitmEmailOtpStyles.termsAck}>
                By continuing, you agree to our{" "}
                <a
                  href="https://firstock.in/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms
                </a>{" "}
                &amp;{" "}
                <a
                  href="https://firstock.in/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </div>
            {/* <div className={ConfitmEmailOtpStyles.firstockApps}>
              <div className={ConfitmEmailOtpStyles.apps}>
                <a
                  href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
                  target="_blank"
                >
                  <img
                    src={GooglePlayStore}
                    className={ConfitmEmailOtpStyles.Googlestoreimage}
                  />
                </a>

                <a
                  href="https://apps.apple.com/us/app/firstock-trade-invest/id6746480444"
                  target="_blank"
                >
                  <img
                    src={AppStore}
                    className={ConfitmEmailOtpStyles.Appstoreimage}
                  />
                </a>

                <a href="https://firstock-common.s3.ap-south-1.amazonaws.com/app/Firstock_INV_Live_Firstock_2023.7.4-setup.zip">
                  <img
                    src={MicroSoft}
                    className={ConfitmEmailOtpStyles.Microstoreimage}
                  />
                </a>
              </div>
              <div className={ConfitmEmailOtpStyles.description}>
                <div className={ConfitmEmailOtpStyles.text1}>
                  Firstock Broking (P) Ltd: NSE & BSE - SEBI
                </div>
                <div className={ConfitmEmailOtpStyles.text1}>
                  Registration No. INZ000260334 | CDSL - SEBI Registration No :
                  IN-
                </div>
                <div className={ConfitmEmailOtpStyles.text1}>
                  DP-67-2015 | Mutual Fund ARN: 132812 | Smart Online Dispute
                  Resolution | SEBI SCORES
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
